import styled from '@emotion/styled';
import { breakpoints } from '../GlobalStyle/GlobalStyle.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 480px;
`;

export const SuccessMessageContainer = styled.div`
  display: flex;
  margin-left: -2px;
  align-items: center;
  color: var(--success);
`;

export const SuccessMessageText = styled.span`
  font-family: var(--font);
  font-weight: var(--font-weight-semi-bold);
  line-height: var(--font-line-height-copy);
  margin-left: var(--spacing-small);

  font-size: var(--font-size-large);

  @media (min-width: ${breakpoints.large}) {
    font-size: var(--font-size-headline);
  }
`;

export const WelcomeMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 28px;

  margin-bottom: var(--spacing-x-large);

  @media (min-width: ${breakpoints.large}) {
    margin-bottom: 64px;
  }
`;

export const WelcomeMessageText = styled.span`
  font-family: var(--font);
  margin-bottom: var(--spacing-x-large);
  color: var(--black-opacity87);
  font-size: 20px;
  font-weight: var(--font-weight-semi-bold);
  line-height: var(--font-line-height-large);
  letter-spacing: 0.15px;

  @media (min-width: ${breakpoints.large}) {
    font-size: 34px;
    font-weight: var(--font-weight-regular);
    letter-spacing: normal;
    line-height: 40px;
  }
`;

export const StoreMessageContainer = styled.div``;

export const StoreMessageText = styled.span`
  letter-spacing: 0.15px;

  font-family: var(--font);
  color: var(--black-opacity60);

  font-size: var(--font-size-large);

  @media (min-width: ${breakpoints.large}) {
    font-size: 20px;
  }
`;

export const StoreLogosContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: var(--spacing-xxx-large);

  margin-top: var(--spacing-xxx-large);
  justify-content: center;

  @media (min-width: ${breakpoints.large}) {
    margin-top: var(--spacing-large);
    justify-content: flex-start;
  }
`;

export const ButtonWrapper = styled.div`
  display: none;

  @media (min-width: ${breakpoints.large}) {
    display: block;
  }
`;
